import { isBlank } from './detailShared'
// S392/S393 (ADDENDUM 38 / RN68 revisada) — cómo se escribe la lista de operarios de una OPERACIÓN
// dentro del recorrido de una PIEZA.
//
// ⚠️ EL SEPARADOR ` · ` YA ESTABA COGIDO, y ese es el motivo de que aquí solo viaje el NOMBRE. En
// las otras dos vistas de este mismo dato —el histórico de interacciones y la franja temporal— un
// operario se escribe `W-11 · Ana Ruiz`: el punto separa CÓDIGO de NOMBRE. Si aquí se listaran
// varios con el mismo punto saldría
//
//     W-11 · Ana Ruiz · W-12 · Luis Gil
//
// que no se puede leer: no hay forma de saber dónde acaba un operario y empieza el siguiente, ni
// cuántos hay. Un separador solo separa si aparece en un nivel. Así que la celda lista NOMBRES, y
// quien necesite el código lo tiene en las otras dos vistas de la misma OF.
//
// 📌 EL RESPALDO NO ES DEFENSA VACÍA. Sun garantiza `workerId` presente —una fila registrada sin
// nadie logueado no aporta operario, y sobre todo no aporta uno anónimo (OperationWorkersPolicy)—
// pero `workerCode` y `workerName` son `Optional` SUELTOS: puede llegar el código sin el nombre.
// Un operario sin nombre NO SE CAE DE LA LISTA: se escribe con lo que haya. Dejarlo fuera sería
// el mismo fallo silencioso del QR de pieza (addendum 40): no un valor feo, sino un dato que
// desaparece, que es el error más difícil de atribuir a su causa.

export const OPERATION_WORKERS_SEPARATOR = ' · '

// Un operario, con la mejor identificación que haya llegado. El `#id` es el último recurso y se ve
// feo A PROPÓSITO: significa "Sun mandó a alguien sin código ni nombre", que es una anomalía del
// dato y debe notarse, no taparse con un literal amable.
export const operationWorkerLabel = (worker) => {
  if (!worker) return ''
  if (!isBlank(worker.workerName)) return String(worker.workerName)
  if (!isBlank(worker.workerCode)) return String(worker.workerCode)
  return isBlank(worker.workerId) ? '' : `#${worker.workerId}`
}

// La lista entera. Vacía devuelve '' — quien la pinta decide el literal de ausencia, porque esa
// decisión es de la vista y no de aquí (RN8: la ausencia se declara, no se interpreta).
export const operationWorkersLabel = (workers) =>
  (workers || []).map(operationWorkerLabel).filter((label) => label !== '').join(OPERATION_WORKERS_SEPARATOR)
